import { Link } from 'react-router-dom';
import './styles.css';
import decor from './decor.png';
import events from './events.png';
import florals from './florals.png';
import hiring from './hiring.png';

const services = [
  {
    title: 'Décor & Design',
    text: 'Tailor-made event décor designed around your style, venue and vision.',
    image: decor,
  },
  {
    title: 'Event Management',
    text: 'Thoughtful planning and practical support to help every part of your event come together.',
    image: events,
  },
  {
    title: 'Floral Design',
    text: 'Beautiful floral arrangements created for celebrations, ceremonies and statement spaces.',
    image: florals,
  },
  {
    title: 'Equipment Hire',
    text: 'Event essentials including chairs, tents, tables, vases and other carefully selected pieces.',
    image: hiring,
  },
];

export const Whatwedo = () => (
  <section id="doing-container" className="services-section">
    <div className="section-shell">
      <div className="services-heading">
        <p className="section-kicker">What we do</p>
        <h2 className="section-title">We create. You celebrate.</h2>
        <p className="section-copy">
          We specialise in event décor, equipment hire, event management and florals — creating
          experiences designed to live on in your memories long after the day itself.
        </p>
      </div>

      <div className="services-grid">
        {services.map((service) => (
          <article className="service-card" key={service.title}>
            <div className="service-image-wrap">
              <img src={service.image} alt={`${service.title} by Rue's Events`} loading="lazy" />
            </div>
            <div className="service-card-copy">
              <span className="service-accent" />
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="services-cta">
        <Link to="/gallery" className="rue-button rue-button--light">Explore Our Gallery</Link>
        <Link to="/contact" className="rue-button">Talk To Our Team</Link>
      </div>
    </div>
  </section>
);
